import { defineMessages } from 'react-intl.macro';

import { OrderSelectionTypesEnum } from '../../openapi/types/OrderSelectionTypesEnum';
import { OrderTypeEnum } from '../../openapi/types/OrderTypeEnum';
import { OriginEnum } from '../../openapi/types/OriginEnum';
import { VydejDmvsSourceEnum } from '../../openapi/types/VydejDmvsSourceEnum';
import { StatusZadateleEnum } from '../../openapi/types/StatusZadateleEnum';

import { ORDER_FROM_PRIMARY_DB, ORDER_IS_PUBLIC } from '../../constants';
import {
  ORDER_STATE,
  APPROVAL_STATE,
  ORDER_DMVS_SOURCE,
} from '../constants';

export const orderMessages = defineMessages({
  reprocessBtn: {
    id: 'order.reprocessBtn',
    defaultMessage: 'Opakovat zpracování',
  },
  interruptBtn: {
    id: 'order.interruptBtn',
    defaultMessage: 'Přerušit zpracování',
  },
  region: {
    id: 'order.region',
    defaultMessage: 'Kraj',
  },
  orp: {
    id: 'order.orp',
    defaultMessage: 'ORP',
  },
  city: {
    id: 'order.city',
    defaultMessage: 'Obec',
  },
  cadaster: {
    id: 'order.cadaster',
    defaultMessage: 'Katastrální území',
  },
  momc: {
    id: 'order.momc',
    defaultMessage: 'Městská část/obvod',
  },
  drawnAreas: {
    id: 'order.drawnAreas',
    defaultMessage: `{customAreasCount, plural,
      one {# graficky definovaná oblast}
      few {# graficky definované oblasti}
      =2 {# graficky definované oblasti}
      =3 {# graficky definované oblasti}
      =4 {# graficky definované oblasti}
      other {# graficky definovaných oblastí}
    }`,
  },
  searchTitle: {
    id: 'map.searchTitle',
    defaultMessage: 'Hledat',
  },
  dmvsSourceEmpty: {
    id: 'order.dmvsSourceEmpty',
    defaultMessage: 'DTM',
  },
  fromPrimaryDB: {
    id: 'newOrder.fromPrimaryDB',
    defaultMessage: '(primární)',
  },
  isPublicValue: {
    id: 'order.isPublicValue',
    defaultMessage: '{is_public, select, true {veřejná} other {neveřejná}}',
  },
});

export const newOrderMessages = defineMessages({
  attachments: {
    id: 'newOrder.attachments.title',
    defaultMessage: 'Přílohy',
  },
  publishSetsStepTitle: {
    id: 'newOrder.publishSetsStep.title',
    defaultMessage: 'Výběr výdejní sady',
  },
  selectRegionNextBtn: {
    id: 'newOrder.selectRegion.nextBtn.label',
    defaultMessage: 'Vybrat zájmovou oblast',
  },
  selectRegionStepTitle: {
    id: 'newOrder.selectRegion.title',
    defaultMessage: 'Výběr zájmové oblasti',
  },
  setReasonStepTitle: {
    id: 'newOrder.setReason.title',
    defaultMessage: 'Důvod žádosti o data',
  },
  reasonPrevBtnLabel: {
    id: 'newOrder.reason.prevBtn.label',
    defaultMessage: 'Změnit důvod žádosti o data',
  },
  reasonNextBtnLabel: {
    id: 'newOrder.reason.nextBtn.label',
    defaultMessage: 'Zadat důvod žádosti o data',
  },
  summaryNextBtnLabel: {
    id: 'newOrder.summary.nextBtn.label',
    defaultMessage: 'Souhrn žádosti o data',
  },
  publishSetsPrevBtnLabel: {
    id: 'newOrder.publishSets.prevBtn.label',
    defaultMessage: 'Změnit výdejní sadu',
  },
  summaryTitle: {
    id: 'newOrder.summary.title',
    defaultMessage: 'Souhrn žádosti o data',
  },
  selectRegionPrevBtnLabel: {
    id: 'newOrder.selectRegion.prevBtn.label',
    defaultMessage: 'Změnit zájmovou oblast',
  },
  submitBtn: {
    id: 'newOrder.submitBtn.label',
    defaultMessage: 'Odeslat žádost o data',
  },
  newOrderBtn: {
    id: 'newOrder.newOrderBtn',
    defaultMessage: 'Zadat novou žádost o data',
  },
  orderListBtn: {
    id: 'newOrder.orderListBtn',
    defaultMessage: 'Přehled žádostí o data',
  },
  orderDetailBtn: {
    id: 'newOrder.orderDetailBtn',
    defaultMessage: 'Detail žádosti o data',
  },
  pageTitle: { id: 'order.pageTitle', defaultMessage: 'Nová žádost o data' },
  queryStateSuccess: {
    id: 'newOrder.success.message',
    defaultMessage:
      'Žádost o data byla úspěšně odeslána a zařazena do {orderListLink}. Po schválení a zpracování žádosti o data budou vaše data k dispozici ke stažení v rámci {orderDetailLink}.',
  },
  orderListLink: {
    id: 'newOrder.success.orderListLink',
    defaultMessage: 'přehledu vašich žádostí o data',
  },
  orderDetailLink: {
    id: 'newOrder.success.orderDetailLink',
    defaultMessage: 'detailu této žádosti o data',
  },
  map: {
    id: 'newOrder.map',
    defaultMessage: 'Zakreslit do mapy',
  },
  shpdgn: {
    id: 'newOrder.shpdgn',
    defaultMessage: 'Importovat SHP(ZIP)/DGN verze 7',
  },
  user: {
    id: 'newOrder.user',
    defaultMessage: 'Odběratel',
  },
  reason: {
    id: 'newOrder.reason',
    defaultMessage: 'Důvod žádosti',
  },
  updateBtn: {
    id: 'newOrder.updateBtn',
    defaultMessage: 'Změnit',
  },
  publishSets: {
    id: 'newOrder.publishSets',
    defaultMessage:
      'Výdejní sady {customerType, select, gp {} other {({order_type, select, STATE {stavová data} other {změnová data}}{show_order_data_state_valid_at, select, true { k {order_data_state_valid_at, date, medium}} other {}}{show_order_data_changes_from, select, true { od {order_data_changes_from, date, medium}} other {}})}}',
  },
  publishSetsPrimary: {
    id: 'newOrder.publishSetsPrimary',
    defaultMessage: 'Výdejní sady - primární databáze',
  },
  emptyPublishSet: {
    id: 'newOrder.emptyPublishSet',
    defaultMessage: 'Není vybrána žádná výdejní sada.',
  },
  noPublishSet: {
    id: 'newOrder.noPublishSet',
    defaultMessage: 'Vyberte alespoň jednu výdejní sadu v 1. kroku.',
  },
  emptyDate: {
    id: 'newOrder.emptyDate',
    defaultMessage: 'Není vyplňeno datum, od kterého jsou data požadována.',
  },
  noDate: {
    id: 'newOrder.noDate',
    defaultMessage: 'Vyplňte v 1. kroku validní datum, od kterého jsou data požadována.',
  },
  area: {
    id: 'newOrder.area',
    defaultMessage: 'Zájmová oblast',
  },
  emptyArea: {
    id: 'newOrder.emptyArea',
    defaultMessage: 'Není vybrána žádná zájmová oblast.',
  },
  noArea: {
    id: 'newOrder.noArea',
    defaultMessage: 'Vyberte alespoň jednu zájmovou oblast v 2. kroku.',
  },
  reasonPlaceholder: {
    id: 'newOrder.reasonPlaceholder',
    defaultMessage: 'Prosím, zadejte důvod vaší žádosti o data...',
  },
  counterDetailsTitle: {
    id: 'newOrder.counterDetails.title',
    defaultMessage: 'Údaje přepážky',
  },
  originLabel: {
    id: 'newOrder.origin.label',
    defaultMessage: 'Původ objednávky',
  },
  origin: {
    id: 'newOrder.origin',
    defaultMessage: 'Objednávka z přepážky',
  },
  handlingFeeLabel: {
    id: 'newOrder.handlingFee.label',
    defaultMessage: 'Manipulační poplatek',
  },
  handlingFee: {
    id: 'newOrder.handlingFee',
    defaultMessage: 'Přičíst k ceně objednávky',
  },
  counterDetailsLockedHint: {
    id: 'newOrder.counterDetails.lockedHint',
    defaultMessage: 'Tyto údaje nejde po založení objednávky změnit.',
  },
  note: {
    id: 'newOrder.note',
    defaultMessage: 'Poznámka',
  },
  detailsStepTitle: {
    id: 'newOrder.details.title',
    defaultMessage: 'Doplňující údaje',
  },
  detailsNextBtnLabel: {
    id: 'newOrder.details.nextBtn.label',
    defaultMessage: 'Zadat doplňující údaje',
  },
  detailsPrevBtnLabel: {
    id: 'newOrder.details.prevBtn.label',
    defaultMessage: 'Změnit doplňující údaje',
  },
  submitConfirmMessage: {
    id: 'newOrder.alert.submit.confirm',
    defaultMessage: 'Vaše změny nejsou uloženy. Přejete si přesto opustit stránku?',
  },
  agreement: {
    id: 'newOrder.agreement',
    defaultMessage: 'Souhlasím s ',
  },
  agreementLink: {
    id: 'newOrder.agreement.link',
    defaultMessage: 'licenčními podmínkami',
  },
  agreementRequired: {
    id: 'newOrder.agreement.required',
    defaultMessage: 'Musíte souhlasit s podmínkami služby',
  },
  queryStateWaiting: {
    id: 'newOrder.queryState.waiting',
    defaultMessage: 'Vaše žádost o data se odesílá...',
  },
  queryStateFail: {
    id: 'newOrder.queryState.fail',
    defaultMessage: 'Vaši žádost o data se nepodařilo odeslat. Zkuste to prosím později.',
  },
  moreItems: {
    id: 'newOrder.multiselect.moreItems',
    defaultMessage: 'Seznam obsahuje větší množství položek, použijte filtr pro upřesnění.',
  },
  noItems: {
    id: 'newOrder.multiselect.noItems',
    defaultMessage: 'Seznam neobsahuje žádné položky.',
  },
  overLimitArea: {
    id: 'newOrder.overLimitArea',
    defaultMessage: 'Plocha definované oblasti je větši než přípustný limit.',
  },
  notSinglePolygonArea: {
    id: 'newOrder.notSinglePolygonArea',
    defaultMessage: 'Definovaná oblast musí být jeden souvislý polygon bez děr.',
  },
  fromPrimaryDB: {
    id: 'newOrder.fromPriparyDB',
    defaultMessage: 'Výdej z primární databáze',
  },
  fromPrimaryDBInfoText: {
    id: 'newOrder.fromPriparyDBInfoText',
    defaultMessage:
      'Budou vydána pouze data, která jsou ve správě kraje a slouží pouze pro krajské editory DI/TI.',
  },
  dataValidityDateFrom: {
    id: 'newOrder.dataValidityDateFrom',
    defaultMessage: 'od',
  },
  dataValidityDate: {
    id: 'newOrder.dataValidityDate',
    defaultMessage: 'k',
  },
  uploadShpDgnErrorText: {
    id: 'newOrder.uploadShpDgnErrorText',
    defaultMessage:
      'Nepodporovaný formát souboru, nebo jeho velikost převyšuje povolenou mez. Podporovány jsou pouze SHP(ZIP) a DGN.',
  },
  isPublicLabel: {
    id: 'newOrder.isPublicLabel',
    defaultMessage: 'Dostupnost',
  },
  selectionTypeLabel: {
    id: 'newOrder.selectionTypeLabel',
    defaultMessage: 'Typ výdeje',
  },
  dataValidityLabel: {
    id: 'newOrder.dataValidityLabel',
    defaultMessage: 'Platnost',
  },
});

export const orderListMessages = defineMessages({
  orderListPageTitle: {
    id: 'orderList.page.title',
    defaultMessage: 'Přehled žádostí o data',
  },
  orderListFiltrLabel: {
    id: 'orderList.label.filter',
    defaultMessage: 'Filtr',
  },
  orderListStateWaiting: {
    id: 'orderList.state.waiting',
    defaultMessage: 'Seznam žádostí o data se načítá...',
  },
  orderListStateFail: {
    id: 'orderList.state.fail',
    defaultMessage: 'Seznam žádostí o data se nepovedlo načíst.',
  },
  orderListStateEmpty: {
    id: 'orderList.state.empty',
    defaultMessage: 'Seznam žádostí o data je prázdný.',
  },
  orderListStateFilteredEmpty: {
    id: 'orderList.state.filteredEmpty',
    defaultMessage: 'Zadanému filtru neodpovídá žádný záznam.',
  },
  orderListColumnState: {
    id: 'orderList.column.state',
    defaultMessage: 'Stav',
  },
  orderListColumnNumber: {
    id: 'orderList.column.number',
    defaultMessage: 'Číslo',
  },
  orderListColumnType: {
    id: 'orderList.column.type',
    defaultMessage: 'Typ výdeje',
  },
  orderListColumnIdPodani: {
    id: 'orderList.column.idPodani',
    defaultMessage: 'ID výdeje',
  },
  orderListColumnImportType: {
    id: 'orderList.column.importType',
    defaultMessage: 'Zdroj výdeje',
  },
  orderListColumnPublishsets: {
    id: 'orderList.column.publishsets',
    defaultMessage: 'Výdejní sady',
  },
  orderListColumnRequiredFormats: {
    id: 'orderList.column.requiredFormats',
    defaultMessage: 'Formáty',
  },
  orderListColumnCreated: {
    id: 'orderList.column.created',
    defaultMessage: 'Podáno',
  },
  orderListColumnPublished: {
    id: 'orderList.column.published',
    defaultMessage: 'K vyzvednutí',
  },
  orderListColumnCreator: {
    id: 'orderList.column.creator',
    defaultMessage: 'Odběratel',
  },
  orderListIsPublicTitle: {
    id: 'orderList.isPublicTitle',
    defaultMessage: 'Dostupnost',
  },
  orderListColumnOrigin: {
    id: 'orderList.column.origin',
    defaultMessage: 'Původ',
  },
});

export const orderStateMessages = defineMessages<ORDER_STATE>({
  [ORDER_STATE.WAITING_FOR_APPROVAL]: {
    id: 'document.orderState.waitingForApproval',
    defaultMessage: 'Čeká na schválení',
  },
  [ORDER_STATE.WAITING_FOR_PROCESSING]: {
    id: 'document.orderState.waitingForProccessing',
    defaultMessage: 'Čeká na zpracování',
  },
  [ORDER_STATE.PROCESSING]: {
    id: 'document.orderState.processing',
    defaultMessage: 'Zpracovává se',
  },
  [ORDER_STATE.WAITING_FOR_INTERRUPTION]: {
    id: 'document.orderState.waitingForInterruption',
    defaultMessage: 'Čeká na přerušení',
  },
  [ORDER_STATE.INTERRUPTED]: {
    id: 'document.orderState.interruption',
    defaultMessage: 'Přerušená',
  },
  [ORDER_STATE.REJECTED]: {
    id: 'document.orderState.rejected',
    defaultMessage: 'Zamítnutá',
  },
  [ORDER_STATE.PUBLISHED]: {
    id: 'document.orderState.published',
    defaultMessage: 'Připravena ke stažení',
  },
  [ORDER_STATE.FAILED]: {
    id: 'document.orderState.failed',
    defaultMessage: 'Chyba při zpracování',
  },
  [ORDER_STATE.DMVS_COMMUNICATION_FAILED]: {
    id: 'document.orderState.dmvsCommunicationFailed',
    defaultMessage: 'Selhala komunikace s IS DMVS',
  },
  [ORDER_STATE.EXPIRED]: {
    id: 'document.orderState.expired',
    defaultMessage: 'Expirovaná',
  },
  [ORDER_STATE.APPROVED]: {
    id: 'document.orderState.approved',
    defaultMessage: 'Schválená',
  }
});

export const orderFilterMessages = defineMessages({
  submitBtn: {
    id: 'orderFilter.submitBtn',
    defaultMessage: 'Filtrovat',
  },
  number: {
    id: 'orderFilter.number',
    defaultMessage: 'Číslo',
  },
  creator: {
    id: 'orderFilter.creator',
    defaultMessage: 'Odběratel',
  },
  state: {
    id: 'orderFilter.state',
    defaultMessage: 'Stav',
  },
  type: {
    id: 'orderFilter.type',
    defaultMessage: 'Typ výdeje',
  },
  dmvs_source: {
    id: 'orderFilter.dmvs_source',
    defaultMessage: 'Zdroj výdeje',
  },
  status_zadatele: {
    id: 'orderFilter.status_zadatele',
    defaultMessage: 'Status žadatele',
  },
  publishset: {
    id: 'orderFilter.publishset',
    defaultMessage: 'Výdejní sada',
  },
  formats: {
    id: 'orderFilter.formats',
    defaultMessage: 'Formáty',
  },
  createdGte: {
    id: 'orderFilter.createdGte',
    defaultMessage: 'Podáno od',
  },
  createdLt: {
    id: 'orderFilter.createdLt',
    defaultMessage: 'Podáno do',
  },
  publishedGte: {
    id: 'orderFilter.publishedGte',
    defaultMessage: 'K vyzvednutí od',
  },
  publishedLt: {
    id: 'orderFilter.publishedLt',
    defaultMessage: 'K vyzvednutí do',
  },
  clearBtn: {
    id: 'orderFilter.clearBtn',
    defaultMessage: 'Zrušit filtr',
  },
  idPodani: {
    id: 'orderFilter.idPodani',
    defaultMessage: 'ID výdeje',
  },
  fromPrimaryDB: {
    id: 'orderFilter.fromPrimaryDB',
    defaultMessage: 'Výdej z primární databáze',
  },
  isPublic: {
    id: 'orderFilter.isPublic',
    defaultMessage: 'Veřejná dostupnost',
  },
  origin: {
    id: 'orderFilter.origin',
    defaultMessage: 'Původ objednávky',
  },
});

export const orderApprovalMessages = defineMessages({
  orderApprovalResult: {
    id: 'order.approval.result',
    defaultMessage: '{state, select, APPROVED { schválil(a) } other { zamítl(a) }}',
  },
  orderApproveBtn: {
    id: 'order.approval.approveBtn',
    defaultMessage: 'Schválit',
  },
  orderRejectBtn: {
    id: 'order.approval.rejectBtn',
    defaultMessage: 'Zamítnout',
  },
  orderApprovalFail: {
    id: 'order.approval.fail',
    defaultMessage: 'Rozhodnutí o schválení se nepodařilo uložit.',
  },
  orderApprovalCloseDialogBtn: {
    id: 'order.approval.closeBtn',
    defaultMessage: 'Zrušit',
  },
  orderApprovalReason: {
    id: 'order.approval.reason',
    defaultMessage: 'Důvod schválení: ',
  },
  orderRejectionReason: {
    id: 'order.rejection.reason',
    defaultMessage: 'Důvod zamítnutí: ',
  },
  orderApprovalReasonError: {
    id: 'order.approval.reason.error',
    defaultMessage: 'Uveďte důvod zamítnutí',
  },
});

export const orderApprovalStateMessages = defineMessages<APPROVAL_STATE>({
  [APPROVAL_STATE.WAITING]: {
    id: 'order.approval.state.WAITING',
    defaultMessage: 'Čeká na schválení',
  },
  [APPROVAL_STATE.APPROVED]: {
    id: 'order.approval.state.APPROVED',
    defaultMessage: 'Schváleno',
  },
  [APPROVAL_STATE.REJECTED]: {
    id: 'order.approval.state.REJECTED',
    defaultMessage: 'Zamítnuto',
  },
});

export const typesMessages = defineMessages<OrderSelectionTypesEnum>({
  [OrderSelectionTypesEnum.CUSTOM]: {
    id: 'newOrder.type.CUSTOM',
    defaultMessage: 'Ad hoc',
  },
  [OrderSelectionTypesEnum.PACKAGE]: {
    id: 'newOrder.type.PACKAGE',
    defaultMessage: 'Balíček',
  },
});

export const dataValidityTypesMessages = defineMessages<OrderTypeEnum>({
  [OrderTypeEnum.STATE]: {
    id: 'newOrder.dataValidity.STATE',
    defaultMessage: 'Stavová data',
  },
  [OrderTypeEnum.CHANGE]: {
    id: 'newOrder.dataValidity.CHANGE',
    defaultMessage: 'Změnová data',
  },
});

export const isPublicMessages = defineMessages({
  [ORDER_IS_PUBLIC.TRUE]: {
    id: 'newOrder.isPublic.TRUE',
    defaultMessage: 'Veřejná',
  },
  [ORDER_IS_PUBLIC.FALSE]: {
    id: 'newOrder.isPublic.FALSE',
    defaultMessage: 'Neveřejná',
  },
});

export const originMessages = defineMessages<OriginEnum>({
  [OriginEnum.EVYDEJ]: {
    id: 'order.origin.EVYDEJ',
    defaultMessage: 'eVýdej',
  },
  [OriginEnum.COUNTER]: {
    id: 'order.origin.COUNTER',
    defaultMessage: 'Přepážka',
  },
});

export const statusZadateleMessages = defineMessages<StatusZadateleEnum>({
  [StatusZadateleEnum.VLASTNIK_SPRAVCE_PROVOZOVATEL]: {
    id: 'newOrder.statusZadatele.VLASTNIK_SPRAVCE_PROVOZOVATEL',
    defaultMessage: 'VSP',
  },
  [StatusZadateleEnum.OPRAVNENY_ZADATEL]: {
    id: 'newOrder.statusZadatele.OPRAVNENY_ZADATEL',
    defaultMessage: 'Oprávněný žadatel',
  },
  [StatusZadateleEnum.AZI]: {
    id: 'newOrder.statusZadatele.AZI',
    defaultMessage: 'AZI',
  },
  [StatusZadateleEnum.ZADATEL_DLE_ZADOSTI]: {
    id: 'newOrder.statusZadatele.ZADATEL_DLE_ZADOSTI',
    defaultMessage: 'Žadatel dle žádosti',
  },
  [StatusZadateleEnum.ORGAN_VEREJNE_MOCI]: {
    id: 'newOrder.statusZadatele.ORGAN_VEREJNE_MOCI',
    defaultMessage: 'Orgán veřejné moci',
  },
  [StatusZadateleEnum.VLASTNIK_DOTCENYCH_NEMOVITOSTI]: {
    id: 'newOrder.statusZadatele.VLASTNIK_DOTCENYCH_NEMOVITOSTI',
    defaultMessage: 'Vlastník dotčených nemovitostí',
  },
});

export const statusZadateleFilterMessages = {
  ...statusZadateleMessages,
  ...defineMessages({
    ['null']: {
      id: 'newOrder.statusZadateleFilter.null',
      defaultMessage: '-',
    },
  }),
};

export const dmvsSourceMessages = defineMessages<VydejDmvsSourceEnum>({
  // NULL => DTM
  [VydejDmvsSourceEnum.R20B_STAVOVA]: {
    id: 'newOrder.dmvsSource.R20B_STAVOVA',
    defaultMessage: 'DMVS (R20b)',
  },
  [VydejDmvsSourceEnum.R20B_ZMENOVA]: {
    id: 'newOrder.dmvsSource.R20B_ZMENOVA',
    defaultMessage: 'DMVS (R20b)',
  },
  [VydejDmvsSourceEnum.R21B_STAVOVA]: {
    id: 'newOrder.dmvsSource.R21B_STAVOVA',
    defaultMessage: 'DMVS (R21b)',
  },
  [VydejDmvsSourceEnum.R21B_ZMENOVA]: {
    id: 'newOrder.dmvsSource.R21B_ZMENOVA',
    defaultMessage: 'DMVS (R21b)',
  },
  [VydejDmvsSourceEnum.R22B_VSP]: {
    id: 'newOrder.dmvsSource.R22B_VSP',
    defaultMessage: 'DMVS (R22b)',
  },
  [VydejDmvsSourceEnum.R27A_NEVEREJNA]: {
    id: 'newOrder.dmvsSource.R27A_NEVEREJNA',
    defaultMessage: 'DMVS (R27a)',
  },
  [VydejDmvsSourceEnum.R27A_VEREJNA]: {
    id: 'newOrder.dmvsSource.R27A_VEREJNA',
    defaultMessage: 'DMVS (R27a)',
  },
  [VydejDmvsSourceEnum.R30B_SYNCHRONIZACNI]: {
    id: 'newOrder.dmvsSource.R30B_SYNCHRONIZACNI',
    defaultMessage: 'DMVS (R30b)',
  },
});

export const dmvsSourceFilterMessages = defineMessages<ORDER_DMVS_SOURCE>({
  [ORDER_DMVS_SOURCE.R20B]: {
    id: 'newOrder.dmvsSourceFilter.R20B',
    defaultMessage: 'DMVS (R20b)',
  },
  [ORDER_DMVS_SOURCE.R21B]: {
    id: 'newOrder.dmvsSourceFilter.R21B',
    defaultMessage: 'DMVS (R21b)',
  },
  [ORDER_DMVS_SOURCE.R22B]: {
    id: 'newOrder.dmvsSourceFilter.R22B',
    defaultMessage: 'DMVS (R22b)',
  },
  [ORDER_DMVS_SOURCE.R27A]: {
    id: 'newOrder.dmvsSourceFilter.R27A',
    defaultMessage: 'DMVS (R27a)',
  },
  [ORDER_DMVS_SOURCE.R30B]: {
    id: 'newOrder.dmvsSourceFilter.R30B',
    defaultMessage: 'DMVS (R30b)',
  },
  [ORDER_DMVS_SOURCE.DTM]: {
    id: 'newOrder.dmvsSourceFilter.DTM',
    defaultMessage: 'DTM',
  },
});

export const fromPrimaryDBMessages = defineMessages<ORDER_FROM_PRIMARY_DB>({
  [ORDER_FROM_PRIMARY_DB.TRUE]: {
    id: 'newOrder.fromPrimaryDB.TRUE',
    defaultMessage: 'Ano',
  },
  [ORDER_FROM_PRIMARY_DB.FALSE]: {
    id: 'newOrder.fromPrimaryDB.FALSE',
    defaultMessage: 'Ne',
  },
});

export const orderPublishsetListMessages = defineMessages({
  publishsetListStateWaiting: {
    id: 'orderPublishsetList.state.waiting',
    defaultMessage: 'Seznam datových sad se načítá.',
  },
  publishsetListStateFail: {
    id: 'orderPublishsetList.state.fail',
    defaultMessage: 'Seznam datových sad se nepovedlo načíst.',
  },
  publishsetListNoFilteredData: {
    id: 'orderPublishsetList.noFilteredData',
    defaultMessage: 'Zadanému filtru neodpovídají žádné výdejní sady.',
  },
  tagsTitle: {
    id: 'orderPublishsetList.tagsTitle',
    defaultMessage: 'Štítky',
  },
});

export const orderPriceMessages = defineMessages({
  previewTitle: {
    id: 'newOrder.price.title',
    defaultMessage: 'Předběžná kalkulace ceny',
  },
  detailTitle: {
    id: 'orderDetail.price.title',
    defaultMessage: 'Cena objednávky',
  },
  publishsetRow: {
    id: 'newOrder.price.publishsetRow',
    defaultMessage: '{area, number} ha · {priceListItemName}',
  },
  publishsetRowVat: {
    id: 'newOrder.price.publishsetRowVat',
    defaultMessage: 'DPH {vatRate, number} %',
  },
  totalGrossLabel: {
    id: 'newOrder.price.totalGrossLabel',
    defaultMessage: 'Celkem s DPH:',
  },
  totalNetLabel: {
    id: 'newOrder.price.totalNetLabel',
    defaultMessage: 'Základ bez DPH:',
  },
  totalVatLabel: {
    id: 'newOrder.price.totalVatLabel',
    defaultMessage: 'DPH:',
  },
  amount: {
    id: 'newOrder.price.amount',
    defaultMessage: '{price} Kč',
  },
  previewError: {
    id: 'newOrder.price.error',
    defaultMessage: 'Předběžnou cenu se nepodařilo vypočítat.',
  },
  handlingFeeRow: {
    id: 'newOrder.price.handlingFeeRow',
    defaultMessage: 'Manipulační poplatek',
  },
});

export const orderTaxableSupplyDateMessages = defineMessages({
  label: {
    id: 'orderDetail.taxableSupplyDate.label',
    defaultMessage: 'DUZP',
  },
  saveBtn: {
    id: 'orderDetail.taxableSupplyDate.saveBtn',
    defaultMessage: 'Uložit DUZP',
  },
  saveError: {
    id: 'orderDetail.taxableSupplyDate.saveError',
    defaultMessage: 'Datum se nepodařilo uložit.',
  },
  infoMissing: {
    id: 'orderDetail.taxableSupplyDate.infoMissing',
    defaultMessage: 'Před uzavřením objednávky vyplňte datum uskutečnění zdanitelného plnění (DUZP).',
  },
});

